<template>
  <div>
    <div class="d-flex align-center pb-5 px-1">
      <div class="cursor-pointer">
        <v-icon
          v-if="!fornecedoresSelecionados.length"
          color="#142454"
          v-text="'mdi-checkbox-blank-outline'"
          @click="fornecedoresSelecionados = fornecedores" />

        <v-icon
          v-else-if="fornecedoresSelecionados.length === fornecedores.length"
          color="#142454"
          v-text="'mdi-checkbox-marked'"
          @click="fornecedoresSelecionados = []" />

        <v-icon
          v-else
          color="#142454"
          v-text="'mdi-minus-box'"
          @click="fornecedoresSelecionados = fornecedores" />
      </div>

      <p
        class="ma-0 ml-1 text-gray font-12 font-weight-medium text-color-333333"
        v-text="'Selecionar todos'"
      />
    </div>

    <v-divider style="margin-right: 25px" />

    <div id="bloco-conteudo">
      <template v-for="fornecedor in fornecedores">
        <Fornecedor
          :key="fornecedor.id_fornecedor"
          :fornecedor="fornecedor"
          :esta_selecionado="fornecedorEstaSelecionado(fornecedor)"
          :expandir="expandir"
          :selecionar="selecionar"
          class="mr-2"
        />
      </template>
    </div>
  </div>
</template>

<script>
import Fornecedor from "./Fornecedor";
import {buscarFornecedoresCotacao} from "@/api/compraPorDepartamentos/Fornecedor";
import ReponsividadeDeAltura from "@/helpers/ResponsiveHeight";
import {logout} from "@/helpers";

export default {
  name: "Fornecedores",
  components: {
    Fornecedor
  },
  mixins: [ReponsividadeDeAltura],
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    pedido: {
      type: Object,
      required: true
    },
    dialog_ativo: Boolean
  },
  data: () => ({
    fornecedores: [],
  }),
  computed: {
    fornecedoresSelecionados: {
      get: function () {
        return this.modelValue;
      },
      set: function (value) {
        this.$emit("update:modelValue", value);
      }
    }
  },
  watch: {
    dialog_ativo: {
      handler(valor) {
        if (!valor) return;

        this.fornecedoresSelecionados = [];
        this.buscarFornecedoresCotacao();
      },
      immediate: true
    }
  },
  methods: {
    buscarFornecedoresCotacao() {
      this.$store.dispatch('loading/addRequisicao',
        buscarFornecedoresCotacao(this.pedido.id).then(this.carregarDadosTabela)).catch(logout);
    },
    carregarDadosTabela(fornecedores) {
      this.fornecedores = fornecedores.map(this.formatarItemFornecedor);
    },
    formatarItemFornecedor(item) {
      item.id_pedido_compra = this.pedido.id;
      item.expandido = false;
      item.departamentos = [];
      return item
    },
    selecionar(fornecedor) {
      if (this.fornecedorEstaSelecionado(fornecedor)) {
        this.fornecedoresSelecionados = this.fornecedoresSelecionados.filter(item => item.id_fornecedor !== fornecedor.id_fornecedor);
      } else {
        this.fornecedoresSelecionados.push(fornecedor);
      }
    },
    expandir(item) {
      item.expandido = !item.expandido;
    },
    fornecedorEstaSelecionado(item) {
      return this.fornecedoresSelecionados.some(f => f.id_fornecedor === item.id_fornecedor)
    }
  }
}
</script>

<style scoped>
#bloco-conteudo {
  height: 49vh;
  overflow-y: auto;
}
</style>
